module.exports = __webpack_public_path__ + "static/sport/in1.83c4bce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/in1.jpg
// module id = pvpM
// module chunks = 0